module.exports = __webpack_public_path__ + "img/heart_10.daf60bf0.png";